import { withStyles } from '@material-ui/styles';
import React, { Component, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connection, portal_config } from '../../../portal.config';
import Loading from '../../components/Loading';
import ModalConfirm from '../../components/ModalConfirm';
import { getAppCfg, getCurrency, setCurrency, setCurrencyCode, setPaymentRecuring } from '../../utils/common';
import crmservices from '../../wsclient/crmservices';
import InvoiceView from './InvoiceView';
import ModalAlert from '../../components/ModalAlert';
import { cignalservices } from '../../wsclient/crmservices/cignalservices';
import { paths, portalCfg } from '../../../portal.router.config';
import Cookies from 'js-cookie';
import { formatDateToDDMMYYYY, formatDateToDDMMYYYYFrEpoch, formatDateToShortMonthName, formatPeriodDate, getPeriodDate, newGUID, statementPeriodOption } from '../../utils/util';
import InvoiceDetailView from './InvoiceDetailView';
import InvoicePrintOut from './InvoicePrintOut';
import moment from 'moment';
import { printHtml, tempInvoice, tempItemInvoice } from '../../utils/printUtil';
import countries from '../../../countries';
import { airlinkservices } from '../../wsclient/crmservices/airlinkservices';
import AddCard from '../order-cards/AddCard';
import { payment } from '../../wsclient/crmservices/payment';
import AllotmentDetail from '../home/AllotmentDetail';
import Barcode from 'react-barcode'

function InvoiceController(props) {
    const { t, classes } = props;
    const [showLoading, setShowLoading] = useState({});
    const [accountFinance, setAccountFinance] = useState({});
    const [wallet, setWallet] = useState({});
    const [confirm, setConfirm] = useState({});
    const [invoices, setInvoices] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [showLoadMore, onShowLoadMore] = useState(false);
    const [printOut, setPrintOut] = useState(null);
    const [primaryCard, setSrimaryCard] = useState(null);
    const [listPeriods, setListPeriods] = useState([
        {
            value: statementPeriodOption.THIS_MONTH,
            label: 'This Month'
        },
        {
            value: statementPeriodOption.LAST_MONTH,
            label: 'Last Month'
        },
        {
            value: statementPeriodOption.THIS_YEAR,
            label: 'This Year'
        },
        {
            value: statementPeriodOption.LAST_YEAR,
            label: 'Last Year'
        },
        {
            value: statementPeriodOption.SPECIFIC_PERIOD,
            label: 'Specific Period'
        },
    ]);
    const [periodSeleted, setPeriodSeleted] = useState(statementPeriodOption.THIS_MONTH);
    const [error, setError] = useState({});
    const [contact, setContact] = useState({});
    const [params, setParams] = useState({
        from_date: formatPeriodDate(getPeriodDate('START_OF_' + statementPeriodOption.THIS_MONTH)),
        to_date: formatPeriodDate(getPeriodDate('END_OF_' + statementPeriodOption.THIS_MONTH)),
        transaction_type: 'INVOICE',
    });
    const [specificPeriod, setSecificPeriod] = useState({
        from_date: formatDateToDDMMYYYY(getPeriodDate('START_OF_' + statementPeriodOption.THIS_MONTH)),
        to_date: formatDateToDDMMYYYY(getPeriodDate('END_OF_' + statementPeriodOption.THIS_MONTH)),
    });
    const [paging, setPaging] = useState(null);
    const [showDetailInvoice, setShowDetailInvoice] = useState(false);
    const [showPrintout, setShowPrintout] = useState(false);
    const [invoiceDetail, setInvoiceDetail] = useState(null);
    const [transactionTypes, setTransactionTypes] = useState([
        {
            value: 'INVOICE',
            label: t('invoice'),
        },
        {
            value: 'PAYMENT',
            label: t('payment'),
        }
    ]);    
    const [showFormAmount, setShowFormAmount] = useState(false);
    const [amount, setAmount] = useState(null);    
    const [openAddCard, setOpenAddCard] = useState(undefined);
	const [htmlContent, setHtmlContent] = useState(undefined);
    const [integration, setIntegration] = useState(null);
    const [payOption, setPayOption] = useState(null);
    const [paymentMethods, setPaymentMethods] = useState({
        credit_cards: [],
        debit_cards: [],
    })
    const [cardSelected, setCardSelected] = useState(null);
    const [walletContact, setWalletContact] = useState({});
    const [showWalletDetail, setShowWalletDetail] = useState(false);

    const currency = getCurrency() ? getCurrency() : portal_config.default_currency;

    const cells = [
        {
            id: 'number',
            name: t('invoice_number')
        },
        {
            id: 'due_date',
            name: t('due_date')
        },
        {
            id: 'date',
            name: t('date_title')
        },
        {
            id: 'transaction_type',
            name: t('transaction_type')
        },
        {
            id: 'amount',
            name: t('invoice_amount'),
            align: 'right'
        },
        {
            id: 'unpaid_amount',
            name: t('unpaid_amount'),
            align: 'right'
        },
        // {
        //     id: 'paid_amount',
        //     name: t('paid_amount'),
        //     align: 'right'
        // },
    ];

    const rows = [
        {
            date: '12 Apr 2022',
            activity: 'Invoice I10024',
            details: 'Due 12/04/2022',
            credit: null,
            debit: '10',
            running_balance: '10'
        },
        {
            date: '12 Apr 2022',
            activity: 'Payment 5040464733210521',
            details: 'Against Invoice(s) I10024',
            credit: "10.5",
            debit: null,
            running_balance: '10.5'
        },
    ]

    useEffect(() => {
        onLoad();
    }, []);

    useEffect(() => {
        if (payOption == 'WALLET' || payOption == 'DEBIT_CARD' || payOption == 'CREDIT_WITHOUT_CARD') {
            setCardSelected(null)
        } else if (payOption == 'CREDIT_CARD') {
            if (paymentMethods && paymentMethods.credit_cards && paymentMethods.credit_cards.length > 0) {
                let cardPrimary = paymentMethods.credit_cards.filter(x => x.is_primary);
                if (cardPrimary && cardPrimary.length > 0) {
                    setCardSelected(cardPrimary[0])
                }
                else setCardSelected(paymentMethods.credit_cards[0])
            }
        }
    },[payOption])

    const onLoad = async () => {
        setShowLoading(true);
        await onLoadWallet();
        await onLoadAccountJournals();
        await onLoadContact();
        getPrimaryCard();
        getIntegrations();
        setShowLoading(false);
    }

    const onLoadWallet = async () => {
        try {
            let result = await crmservices.account.getWalletInfo();
            console.log("AAAAAA load wallet:", result);
            if (result.code === 'OK') {
                //result.data.overdue_amount = 10
                setAccountFinance(result.data);
                setWallet(result.data.wallet);
                // setCurrency(result.data.currency_code ? result.data.currency_code : currency);
                if (result.data.currency_code) setCurrencyCode(result.data.currency_code)
            }
            let resultWallet = await crmservices.account.getWallet();
            if (resultWallet.code == 'OK') setWalletContact(resultWallet.data)

        } catch (error) {
            console.log("load contact error:", error);
        }
    }

    const onLoadContact = async () => {
        try {
            var result = await crmservices.contacts.getContact();
            if (result.code === 'OK') {
                setContact(result.data)
            }
        } catch (error) {
            console.log("load contact error:", error);
        }
    }

    const onPrintInvoice = () => {

    }

    const onPayOld = async () => {
        setShowLoading(true);
        try {
            let isCheckAmount = onValidateAmount(amount);
            if(isCheckAmount){
                if(primaryCard){
                    const result = await crmservices.paymentgateway.createIntent({
                        payment_gateway: "JCC",
                        integration_id: document._portalConfig.facIntegration,
                        payment_method_id: primaryCard.id,
                        amount: amount,
                        currency: accountFinance.currency_code
                    });
                    if (result.code == 'OK' && result.data && result.data.client_secret) {
                        setShowFormAmount(false);
                        const resultConfirm = await crmservices.paymentgateway.payment({
                            client_secret: result.data.client_secret,
                            payment_method: {
                                id: primaryCard.id,
                                type: 'CARD',
                            },
                            amount: amount,
                            currency: accountFinance.currency_code
                        });
                        console.log('resultConfirm: ', resultConfirm)
                        if(resultConfirm.code === 'OK'){
                            //onLoadWallet();
                            await onLoad();
                            showAlert(t('PAYMENT_SUCCESS'));
                        } else {
                            showAlert(t('PAYMENT_FAILED'));
                        }
                    } else {
                        showAlert(t('PAYMENT_FAILED'));
                    }
                }else{
                    showAlert(t('CARD_NOT_FOUND'));
                }
            }
        } catch (ex) {
            console.log("onPayMayaTopup ex:", ex)
            showAlert(t('EXCEPTION_PROCESS'));
        }
    }

    const onPay = async () => {
        setShowLoading(true);
        try {
            let businessName = document._portalConfig.domainCustomer ? document._portalConfig.domainCustomer : 'airlink';
            if(businessName === 'airlink-al-wired') businessName = 'airlinkaw';
            
            let isCheckAmount = onValidateAmount(amount);
            if(isCheckAmount){
                setPaymentRecuring({
                    is_recurring: false,
                    amount: amount,
                });
                let result = await airlinkservices.initiatePayment({
                    amount: amount,
                    organisation: businessName,
                    is_recurring: false,
                });
                console.log("initiatePayment result: ", result);
                if(result.code == 'OK'){
                    setShowLoading(false);                    
                    if(result.data && result.data.client_token){
                        let clientToken = result.data.client_token;
                        let redirectData  = atob(clientToken);
                        console.log('redirectData result===', redirectData)
                        // setOpenAddCard(true);
                        setHtmlContent(redirectData);
                        document.write(redirectData)
                    }
                } else if (result.code === 'CAN_NOT_FIND_CUSTOMER') {
                    showAlert(t('CAN_NOT_FIND_CUSTOMER'));
                }
                else {
                    showAlert(t('TOPUP_FAILED'));
                }
            }
        } catch (ex) {
            console.log("onPay with FAC ex:", ex)
            showAlert(t('EXCEPTION_PROCESS'));
        }
    }

    const getPrimaryCard = async () => {
        try {
            var result = await crmservices.contacts.getListPaymentMethodsV2();
            //console.log("onLoadPaymentMethods result==", result);
            if (result.code == 'OK') {
                let cards = result.data.content ? result.data.content : [];
                let primaryCards = cards.filter(c => {
                    return c.is_primary
                })
                if (primaryCards && primaryCards.length > 0) {
                    setSrimaryCard(primaryCards[0]);
                }
                let _creditCards = [];
                let _debitCards = [];
                if (result.data && result.data.content && result.data.content.length > 0) {
                    result.data.content.forEach(element => {
                        if (element.payment_method_type == 'CARD' && element.card && element.card.gateway_token && element.card.gateway_token.length > 0) {
                            let gateway_token = element.card.gateway_token[0];
                            if (gateway_token.integration && gateway_token.integration.name) {
                                if (gateway_token.integration.name.includes('FAC')) _debitCards.push(element)
                                else _creditCards.push(element)
                            }
                        }
                    });
                }
                setPaymentMethods({
                    credit_cards: _creditCards,
                    debit_cards: _debitCards,
                })
            }
        } catch (error) {
            console.log("on load payment method exception:", error);
        }
    }

    const showAlert = (message) => {
        setShowLoading(false);
        setError({
            showAlert: true,
            message: message,
        });
    }

    const onCloseAlert = () => {
        setShowLoading(false);
        setError({
            showAlert: false,
            message: '',
        });
    }

    const onSelectPeriod = (event) => {
        setPeriodSeleted(event.target.value);
    }

    const onLoadAccountJournals = async (newParams) => {
        try {
            console.log("newParams==", newParams);
            let result = await crmservices.account.getAccountJournals(newParams ? newParams : params);
            console.log("AAAAAA load getAccountJournals:", result);
            if (result.code === 'OK') {
                setInvoices(result.data.content);
                setPaging(result.data.paging);
            }
        } catch (error) {
            console.log("load getAccountJournals error:", error);
        }
    }

    const handleChangePage = async (event, newPage) => {
        console.log("newPage ===", newPage);
        try {
            onShowLoadMore(true);
            setPaging({
                ...paging,
                page: newPage + 1,
            });
            let newParams = {
                ...params,
                page: newPage + 1,
            };
            setParams(newParams);
            await onLoadAccountJournals(newParams);
            onShowLoadMore(false);
        }
        catch (ex) {
            console.log("load next page handleChangePage==", ex);
        }
    };

    const onChangeType = async (type) => {
        let newParams = {
            ...params,
            transaction_type: type,
        }
        setParams(newParams);
        // await onLoadAccountJournals(newParams);
    }

    const onFilter = async (values) => {
        setShowLoading(true);
        const { from_date, to_date } = values;
        let newParams = { ...params };
        setParams(newParams);
        if (periodSeleted != statementPeriodOption.SPECIFIC_PERIOD) {
            let fromDate = getPeriodDate('START_OF_' + periodSeleted);
            let toDate = getPeriodDate('END_OF_' + periodSeleted);
            console.log("fromDate==" + fromDate + ", toDate===" + toDate);
            newParams.from_date = formatPeriodDate(fromDate);
            newParams.to_date = formatPeriodDate(toDate);
        } else {
            let fromDate = typeof from_date == 'function' ? new Date(from_date.format("DD/MM/YYYY")) : new Date(formatDateDDMMYYYY(from_date));
            let toDate = typeof to_date == 'function' ? new Date(to_date.format("DD/MM/YYYY")) : new Date(formatDateDDMMYYYY(to_date));
            console.log("fromDate===", fromDate);
            console.log("toDate===", toDate);
            newParams.from_date = formatPeriodDate(fromDate);
            newParams.to_date = formatPeriodDate(toDate);
        }
        console.log("newParams===", newParams);
        setParams(newParams);
        await onLoadAccountJournals(newParams);
        setShowLoading(false);
    }

    const onDetailInvoice = async (invoice) => {
        setShowLoading(true);
        try {
            setInvoiceDetail(invoice);
            let result = await crmservices.account.getJournal(invoice.id);
            console.log("AAAAAA load onDetailInvoice:", result);
            if (result.code === 'OK') {
                setInvoiceDetail(result.data);
                setShowDetailInvoice(true);
            }
        } catch (error) {
            console.log("load onDetailInvoice error:", error);
        }
        setShowLoading(false);
    }

    const onPrint = async (entity_id) => {
        setShowLoading(true);
        try {
            // setShowPrintout(true);
            var content = tempInvoice;
            let logoLink = document._portalConfig.logoLink;
            let footerLink = document._portalConfig.footerLink;
            
            let addressPrimary = await onLoadContactAddresses();
            let address = '';
            if(addressPrimary){
                if(addressPrimary.address_line_1) address += addressPrimary.address_line_1;
                if(addressPrimary.address_line_2) address += ", " + addressPrimary.address_line_2;
                if(addressPrimary.town_city) address += ", " + addressPrimary.town_city;
                if(addressPrimary.country_code){
                    let country = countries.filter(x => x.value === addressPrimary.country_code);
                    if(country && country.length > 0){
                        address += ", " + country[0].label;
                    }
                }
            }
            // console.log("AAAA sectionBarCodeHTML: ", sectionBarCodeHTML)
            // content = content.replaceAll('#BARCODE', sectionBarCodeHTML)
            let sectionBarCodeHTML = document.getElementById('print_barcode').innerHTML;
            if (sectionBarCodeHTML) {
                sectionBarCodeHTML = sectionBarCodeHTML.replace(`style="transform: translate(0,0)"`, `style="transform: translate(0,0);width: 100px;height: 50px"`);
                console.log("AAAA sectionBarCodeHTML: ", sectionBarCodeHTML)
                content = content.replaceAll("#BARCODE", sectionBarCodeHTML)
            }
            content = content.replaceAll("#LOGO_LINK", logoLink)
            content = content.replaceAll("#FOOTER_LINK", footerLink)
            content = content.replaceAll("#ADDRESS", address);
            content = content.replaceAll("#INVOICE_NUMBER", invoiceDetail.number);
            content = content.replaceAll("#CUSTOMER_CODE", contact.code);
            content = content.replaceAll("#CUSTOMER_NAME", contact.first_name + ' ' + contact.last_name);
				
            content = content.replaceAll("#INVOICE_DATE", formatDateToDDMMYYYYFrEpoch(invoiceDetail.posted_date, true));
            content = content.replaceAll("#DUE_DATE", formatDateToDDMMYYYYFrEpoch(invoiceDetail.invoice.due_date, true));

            content = content.replaceAll("#TOTAL_NET_AMOUNT", "" + invoiceDetail.net.toFixed(2));
            content = content.replaceAll("#TOTAL_DISCOUNT_AMOUNT", "" + invoiceDetail.discount.toFixed(2));
            content = content.replaceAll("#TOTAL_TAX_AMOUNT", "" + invoiceDetail.tax.toFixed(2));
            content = content.replaceAll("#TOTAL_AMOUNT", "" + invoiceDetail.total.toFixed(2));
            content = content.replaceAll("#OVERDUE_AMOUNT", "" + invoiceDetail.invoice.overdue_amount.toFixed(2));

	        var itemContent = "";
            if (invoiceDetail.lines && invoiceDetail.lines.length > 0){
                invoiceDetail.lines.map(item=>{
	                var row = tempItemInvoice;

                    row = row.replaceAll("#ITEM_NAME", item.product.name);
                    row = row.replaceAll("#ITEM_QUANTITY", "" + item.quantity);
                    row = row.replaceAll("#ITEM_UNIT_PRICE", "" + item.unit_price.toFixed(2));
                    row = row.replaceAll("#ITEM_DISCOUNT", "" + item.discount.toFixed(2));
                    row = row.replaceAll("#TAX_AMOUNT", "" + item.tax.toFixed(2));
                    row = row.replaceAll("#SUB_TOTAL", "" + item.net.toFixed(2));
                    itemContent = itemContent + row;
                })
            }
            content = content.replaceAll("#ITEM_INFO", "" + itemContent);

            // console.log("AAAA content: ", content)
           // const result = await crmservices.printout.printInvoice(entity_id);
           // console.log("result onPrint:", result)
            //if (result.code == 'OK') {
                //setPrintOut(result.data);
                // setShowPrintout(true);
                printHtml(content);
           // }
            // printHtml(tempInvoice);
        } catch (error) {
            console.log("onPrint error:", error);
        }
        setShowLoading(false);
    }

    const onConfirmPay = async () => {
        await onLoad();
        setShowFormAmount(true);
    }

    const onChangeAmount = (value) => {
        setAmount(value);
    }

    const onValidateAmount = (value) => {
        console.log("value===", value);
        let validate = false;
        let balance = accountFinance && accountFinance.balance ? accountFinance.balance : 0;
        let amount = Number(value);
        // if( amount > balance){
        //     validate = false;
        //     showAlert(t('amount_less_equal_than') + balance + "!");
        // } else 
        if(amount <= 0){
            validate = false;
            showAlert(t('amount_greater_than'));
        }
        else{
            validate = true;
        }
        return validate;
    }

    const onLoadContactAddresses = async () => {
        let addressPrimary = null;
        try {
            var result = await crmservices.contacts.getAddresses();
            if (result.code === 'OK') {
                if(result.data && result.data.content && result.data.content.length >0){
                    for (let index = 0; index < result.data.content.length; index++) {
                        const item = result.data.content[index];
                        if(item.is_primary){
                            addressPrimary = item;
                            break;
                        }
                    }
                }
            }
        } catch (error) {
            console.log("load contact addresses error:", error);
        }
        return addressPrimary;
    }

    const onPayWithCreditCard = async () => {
        setShowLoading(true);
        try {
            let businessName = document._portalConfig.domainCustomer ? document._portalConfig.domainCustomer : 'airlink';
            if(businessName === 'airlink-al-wired') businessName = 'airlinkaw';

            let token = newGUID();
            let redirectUrl = `${window.location.origin}${paths.process_payment}?token=${token}`
            let isCheckAmount = onValidateAmount(amount);
            if(isCheckAmount){
                setPaymentRecuring({
                    is_recurring: false,
                    amount: amount,
                    token: token,
                    from: 'invoice',
                    type: 'TOP_UP',
                    payment_method_id: cardSelected && cardSelected.id,
                    topup_gateway: connection.crmConfig.isOpenStripe ? 'Stripe' : 'CRM.COM Payment Gateway',
                    is_one_time_payment: cardSelected && cardSelected.id ? false : true,
                });
                let integrationId = connection.crmConfig.isOpenStripe ? connection.crmConfig.stripeIntegration : integration?.id;
                let body = {
                    integration_id: integrationId,
                    redirect_url: redirectUrl,
                    amount: Number(amount),
                    currency_code: accountFinance.currency_code,
                    device_type: 'BROWSER',
                    type: 'TOP_UP',
                    header_accept: '*/*',
                    header_accept_language: navigator.language,
                    browser_color_depth: window.screen.colorDepth,
                    browser_screen_height: window.screen.availHeight,
                    browser_screen_width: window.screen.availWidth,
                    browser_java_enabled: false,
                    time_zone_offset: -(new Date()).getTimezoneOffset(),
                    user_agent: navigator.userAgent
                }
                if (cardSelected && cardSelected.id) body.payment_method_id = cardSelected.id;
                let result = await payment.getPaymentForm(body);
                console.log("initiatePayment result: ", result);
                if(result.code == 'OK'){
                    setShowLoading(false);                    
                    let data = result.data ? JSON.parse(result.data) : null;
                    if (data && data.form_url) window.location.href = data.form_url;
                }
                else {
                    let error = result.data && result.data.message ? result.data.message : 'Have an error Pay with Crebit Card'
                    if (result.data && result.data.parameters) error += ' ' + result.data.parameters.join(',');
                    showAlert(error);
                }
            }
        } catch (ex) {
            console.log("onPayWithCreditCard exception:", ex)
            showAlert(t('EXCEPTION_PROCESS'));
        }
    }

    const onPayWithWalletBalance = async () => {
        setShowLoading(true)
        try {
            let result = await payment.createPayment({
                amount: Number(amount),
                account_id: accountFinance.id,
                payment_method: {
                    type: 'CRM_WALLET',
                },
                external_payable: [{
                    reference: new Date().getTime(),
                }],
                notes: 'Airlink Portal create payment',
                custom_fields: [
                    {
                        key: 'payment_gateway',
                        value: 'CRM_WALLET',
                    }
                ],
            })
            console.log("AAAA onPayWithWalletBalance result: ", result)
            if (result.code == 'OK') {
                showAlert(t('PAYMENT_SUCCESS'));
                setShowFormAmount(false)
                onLoad();
            } else {
                let error = result.data && result.data.message ? result.data.message : 'Have an error Pay with Wallet Balance'
                if (result.data && result.data.parameters) error += ' ' + result.data.parameters.join(',');
                showAlert(error);
            }
        } catch (error) {
            console.log("AAAA onPayWithWalletBalance error: ", error)
        }
        setShowLoading(false)
    }

    const getIntegrations = async () => {
        if (connection.crmConfig.isOpenStripe) {
            setIntegration({ id: connection.crmConfig.stripeIntegration })
            return;
        }
        try {
            let portalConfig = getAppCfg();
            let result = await payment.getIntegrations({
                connector: 'SOLIDGATE'
            }, portalConfig.id);
            console.log("AAAA getIntegrations result: ", result)
            if (result.code == 'OK') {
                if (result.data && result.data.content && result.data.content.length > 0) setIntegration(result.data.content[0])
            }
        } catch (error) {
            console.log("AAAA getIntegrations error: ", error)
        }
    }

    const initTopup = async () => {
        setShowLoading(true);
        try {
            let businessName = document._portalConfig.domainCustomer ? document._portalConfig.domainCustomer : 'airlink';
            if(businessName === 'airlink-al-wired') businessName = 'airlinkaw';
            
            let isCheckAmount = onValidateAmount(amount);
            if(isCheckAmount){
                setPaymentRecuring({
                    is_recurring: false,
                    amount: amount,
                    type: 'TOPUP',
                    wallet_id: wallet && wallet.id,
                    account_id: accountFinance.id,
                });
                let result = await airlinkservices.initiateTopup({
                    amount: amount,
                    organisation: businessName,
                    is_recurring: false,
                    wallet_id: wallet && wallet.id,
                });
                console.log("initiatePayment result: ", result);
                if(result.code == 'OK'){
                    setShowLoading(false);                    
                    if(result.data && result.data.client_token){
                        let clientToken = result.data.client_token;
                        let redirectData  = atob(clientToken);
                        console.log('redirectData result===', redirectData)
                        // setOpenAddCard(true);
                        setHtmlContent(redirectData);
                        document.write(redirectData)
                    }
                } else if (result.code === 'CAN_NOT_FIND_CUSTOMER') {
                    showAlert(t('CAN_NOT_FIND_CUSTOMER'));
                }
                else {
                    showAlert(t('TOPUP_FAILED'));
                }
            }
        } catch (ex) {
            console.log("onPay with FAC ex:", ex)
            showAlert(t('EXCEPTION_PROCESS'));
        }
    }

    const onSubmit = async () => {
        console.log("AAAA onSubmit payOption: ", payOption)
        console.log("AAAA onSubmit wallet: ", wallet)
        console.log("AAAA onSubmit amount: ", amount)
        if (!payOption) {
            showAlert('Please choose a pay option!');
            return false;
        }
        if (!amount || amount < 0) {
            showAlert('Please enter amount!');
            return false;
        }
        
        if (payOption == 'WALLET') {
            if (accountFinance.balance == 0) {
                showAlert(`Payment Failed. No due amount.`);
                return false;
            }
            else if (accountFinance.balance > 0) {
                if (amount > accountFinance.balance) {
                    showAlert(`Please specify an amount not exceeding ${accountFinance.balance}`);
                    return false;
                }
            }
            if (amount <= wallet.balance) await onPayWithWalletBalance();
            else {
                showAlert('Wallet funds are not enough to pay the account balance. Please choose another pay option.');
                return false;
            }
        }
        else if (payOption == 'CREDIT_CARD' || payOption == 'CREDIT_WITHOUT_CARD') {
            // if (cardSelected && cardSelected.id) {
            //     await createPayment();
            // } else {
            //     await onPayWithCreditCard();
            // }
            await onPayWithCreditCard();
        }
        else if (payOption == 'DEBIT_CARD') {
            await initTopup();
        }
    }

    const createPayment = async () => {
        console.log("AAAA createPayment cardSelected: ", cardSelected)
        let integration = null;
        if (cardSelected && cardSelected.card && cardSelected.card.gateway_token && cardSelected.card.gateway_token.length > 0) {
            let gateway_token = cardSelected.card.gateway_token[0];
            if (gateway_token && gateway_token.integration) {
                integration = gateway_token.integration;
            }
        }
        if (!integration) {
            showAlert('Not found integration gateway!')
            return false;
        }
        setShowLoading(true)
        try {
            let result = await payment.createPayment({
                integration_id: integration.id,
                amount: Number(amount),
                account_id: accountFinance.id,
                payment_method: {
                    type: 'CARD',
                    id: cardSelected.id,
                },
                external_payable: [{
                    reference: new Date().getTime(),
                }],
                notes: 'Airlink Portal create payment',
                custom_fields: [
                    {
                        key: 'payment_gateway',
                        value: integration.name,
                    }
                ],
            })
            console.log("AAAA createPayment result: ", result)
            if (result.code == 'OK') {
                showAlert(t('PAYMENT_SUCCESS'))
                setShowFormAmount(false)
                onLoad();
            } else {
                let error = result.data && result.data.message ? result.data.message : 'Have an error Pay with Wallet Balance'
                if (result.data && result.data.parameters) error += ' ' + result.data.parameters.join(',');
                showAlert(error);
            }
        } catch (error) {
            console.log("AAAA createPayment error: ", error)
            showAlert(t('EXCEPION_PROCESS'));
        }
        setShowLoading(false)
    }

    const onChangeCardSelect = (item, option) => {
        setCardSelected(item)
        if (option == 'CREDIT_CARD') {
            setPayOption(option)
        }
    }

    const onCloseFormAmount = () => {
        setAmount(null);
        setShowFormAmount(false)
        setPayOption(null)
        setCardSelected(null)
    }
    return (
        <>
            <InvoiceView
                currency={currency}
                wallet={wallet}
                walletContact={walletContact}
                accountFinance={accountFinance}
                rows={invoices}
                cells={cells}
                hasMore={hasMore}
                showLoadMore={showLoadMore}
                listPeriods={listPeriods}
                periodSeleted={periodSeleted}
                paging={paging}
                params={params}
                specificPeriod={specificPeriod}
                transactionTypes={transactionTypes}
                showFormAmount={showFormAmount}
                payOption={payOption}
                paymentMethods={paymentMethods}
                cardSelected={cardSelected}
                onChangeAmount={onChangeAmount}
                onConfirmPay={onConfirmPay}
                onPrintInvoice={onPrintInvoice}
                onPay={onPay}
                onFilter={onFilter}
                onSelectPeriod={onSelectPeriod}
                handleChangePage={handleChangePage}
                onDetailInvoice={onDetailInvoice}
                onChangeType={onChangeType}
                setParams={setParams}
                setShowFormAmount={setShowFormAmount}
                onSubmit={onSubmit}
                setPayOption={setPayOption}
                setCardSelected={setCardSelected}
                setAmount={setAmount}
                onChangeCardSelect={onChangeCardSelect}
                onCloseFormAmount={onCloseFormAmount}
                setShowWalletDetail={setShowWalletDetail}
            />
            <div id='print_barcode' style={{ display: 'none' }}>
                <Barcode value={contact.code} displayValue={false} fontSize={18} textMargin={0} margin={0}/>
            </div>
            {openAddCard && <AddCard
                open = {openAddCard}
				form_id="powertranz_spi"
				// isOverwriteDocument={true}
                onClose = {() => setOpenAddCard(false)} 
                html_add_card_content = {htmlContent}   
            />}
            {showLoading && <Loading showLoading={showLoading} />}
            {confirm && <ModalConfirm
                open={confirm.show}
                onClose={() => setConfirm({})}
                message={confirm.message}
                confirm={confirm.actionTitle}
            />}
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
            />
            {showDetailInvoice && <InvoiceDetailView
                open={showDetailInvoice}
                item={invoiceDetail}
                currency={currency}
                contact={contact}
                onClose={() => setShowDetailInvoice(false)}
                onPrint={onPrint}
            />}
            {showPrintout && <InvoicePrintOut
                open={showPrintout}
                printOut={printOut}
                currency={currency}
                onClose={() => setShowPrintout(false)}
            />}
            {showWalletDetail && <AllotmentDetail
                open={showWalletDetail}
                wallet={wallet}
                currency={currency}
                onCloseAllotment={() => setShowWalletDetail(false)} 
            />}
        </>
    );
}

function formatDateDDMMYYYY(date) {
    var dateMomentObject = moment(date, "DD/MM/YYYY"); // 1st argument - string, 2nd argument - format
    var dateObject = dateMomentObject.toDate();
    return dateObject;
}
export default (withTranslation()(InvoiceController));
